import React, { useMemo } from 'react';
import qrcode from 'qrcode-generator';

const QUIET_ZONE = 4;

function getModules(value) {
  const qr = qrcode(0, 'M');
  qr.addData(value);
  qr.make();

  const moduleCount = qr.getModuleCount();
  const darkModules = [];

  for (let row = 0; row < moduleCount; row++) {
    for (let col = 0; col < moduleCount; col++) {
      if (qr.isDark(row, col)) {
        darkModules.push([row, col]);
      }
    }
  }

  return { moduleCount, darkModules };
}

const QRCode = ({ value, size = 280 }) => {
  const qrValue = String(value || '');
  const { moduleCount, darkModules } = useMemo(
    () => getModules(qrValue),
    [qrValue],
  );
  const viewBoxSize = moduleCount + QUIET_ZONE * 2;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}
      shapeRendering="crispEdges"
      role="img"
      aria-label="Membership QR code">
      <rect width={viewBoxSize} height={viewBoxSize} fill="#fff" />
      {darkModules.map(([row, col]) => (
        <rect
          key={`${row}-${col}`}
          x={col + QUIET_ZONE}
          y={row + QUIET_ZONE}
          width={1}
          height={1}
          fill="#000"
        />
      ))}
    </svg>
  );
};

export default QRCode;
